import { useContext } from 'react'

import { Form } from 'components/Form'
import { PrebidModulesContext } from 'features/globalSetup/contexts/PrebidModulesContext'
import { useCreatePrebidModule } from '../../hooks/useCreatePrebidModule'
import { AddSchema, addSchema, addSchemaDefault } from '../../schemas/addSchema'
import { UserIdsForm } from './UserIdsForm'

export const AddContainer = (): React.JSX.Element => {
  const { formId, loading, setLoading, setTouched, setValid } = useContext(PrebidModulesContext)
  const { create, errors: apiErrors } = useCreatePrebidModule({
    moduleType: 'userId',
    setLoading,
  })

  return (
    <Form<AddSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={create}
      onTouched={setTouched}
      onValid={setValid}
      schema={addSchema}
      schemaDefaults={addSchemaDefault}
    >
      {() => <UserIdsForm variant='add' />}
    </Form>
  )
}
